import { useQuery } from "@tanstack/react-query";
import api from "../../http";
import { UserDTO } from "../../../users/types";

export interface UseGetUsersParams {
    page?: number;
    limit?: number;
    userNameOrEmail?: string;
    role?: string;
    rootOwnerName?: string;
    enabled?: boolean;
    status?: boolean;
}

export interface PaginatedUsersResponse {
    totalDocs: number;
    limit: number;
    totalPages: number;
    page: number;
    docs: UserDTO[];
}

export interface FetchUsersParams {
    page?: number;
    limit?: number;
    userNameOrEmail?: string;
    role?: string;
    rootOwnerName?: string;
    status?: boolean;

}

export const fetchUsers = async ({
    page = 1,
    limit = 1000,
    userNameOrEmail = '',
    role = '',
    rootOwnerName = '',
    status
}: FetchUsersParams = {}) => {
    const { data } = await api.get<PaginatedUsersResponse>('/management/user/findAll', {
        params: { page, limit, userNameOrEmail, role, rootOwnerName, status }
    });
    return data;
};

export function useGetUsers({
    page = 1,
    limit = 10,
    userNameOrEmail = '',
    role = '',
    rootOwnerName = '',
    enabled = true,
    status = true
}: UseGetUsersParams = {}) {
    const query = useQuery<PaginatedUsersResponse>({
        queryKey: ['users', page, limit, userNameOrEmail, role, rootOwnerName, status],
        enabled,
        placeholderData: (previousData) => previousData,
        queryFn: () => fetchUsers({ page, limit, userNameOrEmail, role, rootOwnerName, status }),
    });

    return {
        ...query,
        data: query.data?.docs ?? [],
        pagination: query.data ? {
            totalDocs: query.data.totalDocs,
            totalPages: query.data.totalPages,
            page: query.data.page,
        } : null,
    };
}
